var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightIcon = function SvgRightIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 10.25h3.5v3.5h-3.5v-3.5ZM10.25 10.25h3.5v3.5h-3.5v-3.5ZM17.25 10.25h3.5v3.5h-3.5v-3.5Z",
    fill: "#fff"
  })));
};
export default SvgRightIcon;